export default __webpack_public_path__ + "static/img/shogun-spinner.2f1fe716.gif";